import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CategoryService, PaceBoundaryService, SyllabusQuery } from '@examdojo/category/v2';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { EMPTY, merge, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FetchCategoryBoundariesOnSyllabusContextChangeEffectService {
  constructor(
    private readonly paceBoundaryService: PaceBoundaryService,
    private readonly categoryService: CategoryService,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly syllabusQuery: SyllabusQuery,
  ) {
    merge(this.fetchPaceBoundaries(), this.fetchGradeBoundaries()).pipe(takeUntilDestroyed()).subscribe();
  }

  private fetchPaceBoundaries() {
    return this.syllabusQuery.activeIdAndCourseLevel$.pipe(
      switchMap((syllabusContext) =>
        this.paceBoundaryService
          .fetchPaceBoundariesByCourseLevel(syllabusContext)
          .pipe(this.errorHandlerService.catchHttpErrors(() => EMPTY)),
      ),
    );
  }

  private fetchGradeBoundaries() {
    return this.syllabusQuery.activeIdAndCourseLevel$.pipe(
      switchMap((syllabusContext) =>
        this.categoryService
          .fetchGradeBoundaries(syllabusContext)
          .pipe(this.errorHandlerService.catchHttpErrors(() => EMPTY)),
      ),
    );
  }
}
